(function () {
  var S = [[46,'XS'],[59,'S'],[66,'M'],[80,'L'],[92,'XL']];
  var B = [{n:'Beagle',l:48},{n:'Bernese Mountain Dog',l:78,f:1},{n:'Border Collie',l:55,f:1},{n:'Border Terrier',l:40},{n:'Boxer',l:62,d:1},{n:'Cavalier King Charles',l:42,f:1},{n:'Chihuahua',l:25},{n:'Cockapoo',l:45,f:1},{n:'Cocker Spaniel',l:48,f:1},{n:'Dachshund',l:48},{n:'Dalmatian',l:62,d:1},{n:'Doberman',l:68,d:1},{n:'French Bulldog',l:40},{n:'German Shepherd',l:70,f:1},{n:'Golden Retriever',l:65,f:1},{n:'Goldendoodle',l:62,f:1},{n:'Great Dane',l:90,d:1},{n:'Greyhound',l:70,d:1},{n:'Hungarian Vizsla',l:60,d:1},{n:'Jack Russell',l:38},{n:'Labradoodle',l:60,f:1},{n:'Labrador',l:62},{n:'Lurcher',l:66,d:1},{n:'Miniature Schnauzer',l:40},{n:'Newfoundland',l:85,f:1},{n:'Poodle, standard',l:60,f:1},{n:'Pug',l:38},{n:'Rhodesian Ridgeback',l:75,d:1},{n:'Rottweiler',l:70},{n:'Samoyed',l:60,f:1},{n:'Shih Tzu',l:35,f:1},{n:'Springer Spaniel',l:55,f:1},{n:'Staffordshire Bull Terrier',l:48},{n:'West Highland Terrier',l:38,f:1},{n:'Whippet',l:55,d:1}];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function idx(l) { for (var i = 0; i < S.length; i++) { if (l <= S[i][0]) return i; } return S.length - 1; }

  function init() {
    var sel = document.getElementById('fidBreed');
    var len = document.getElementById('fidLen');
    var pup = document.getElementById('fidPup');
    var out = document.getElementById('fidOut');
    if (!sel || !len || !out || sel.dataset.ready) return;
    sel.dataset.ready = '1';

    B.forEach(function (b, i) {
      var o = document.createElement('option');
      o.value = i;
      o.textContent = b.n;
      sel.appendChild(o);
    });

    function run() {
      var b = sel.value === '' ? null : B[sel.value];
      var typed = parseFloat(len.value);
      var l = typed > 0 ? typed : (b ? b.l : 0);
      if (!l) { out.hidden = true; out.innerHTML = ''; return; }
      if (l > 92) {
        out.hidden = false;
        out.innerHTML = '<strong>XL, our largest size</strong><p>At ' + l + 'cm your dog is above the top of our range. Measure the chest as well and get in touch before ordering, because XL may still be snug.</p>';
        return;
      }
      var notes = [], bump = false, why = '';
      var i = idx(l), slack = S[i][0] - l;
      if (slack <= 4 && i < S.length - 1) {
        bump = true;
        why = 'At ' + l + 'cm you are right at the top of ' + S[i][1] + ', so the next size up will fit better.';
      }
      if (b && b.f && i < S.length - 1 && !bump) {
        bump = true;
        why = 'A thick coat takes up the slack in the belly flap, so we size up for a ' + b.n + '.';
      }
      var size = bump ? S[i + 1][1] : S[i][1];
      if (!why) { why = 'A back length of ' + l + 'cm sits comfortably inside ' + size + '.'; }
      if (b && b.f && why.indexOf('thick coat') === -1) {
        notes.push('Thick coat, so the belly flap has less slack than the measurement suggests.');
      }
      if (b && b.d) {
        notes.push('Deep chested breed. Check the chest as well as the back length, because that is where the robe pulls first.');
      }
      if (pup && pup.checked) {
        notes.push('Still growing, so buy for the adult size rather than the size today.');
      }
      notes.push('Between two sizes? Always go up. A slightly roomier robe dries faster than a tight one.');
      var h = '<strong>You need ' + esc(size) + '</strong><p>' + esc(why) + '</p><ul>';
      for (var k = 0; k < notes.length; k++) { h += '<li>' + esc(notes[k]) + '</li>'; }
      h += '</ul>';
      out.hidden = false;
      out.innerHTML = h;
    }

    sel.addEventListener('change', function () { len.value = ''; run(); });
    len.addEventListener('input', function () { if (len.value !== '') { sel.value = ''; } run(); });
    if (pup) { pup.addEventListener('change', run); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 80); }).observe(document.documentElement, { childList: true, subtree: true });
})();
